export default {
  title: 'Riepilogo vendite',
  description:
    'Vendite per il periodo selezionato — da usare per la riconciliazione di fatturazione con questo ristorante.',
  filters: {
    period: 'Periodo',
  },
  presets: {
    this_month: 'Questo mese',
    last_month: 'Mese scorso',
    last_30_days: 'Ultimi 30 giorni',
    this_year: "Quest'anno",
  },
  fields: {
    orders_count: 'Ordini',
    net_sales: 'Vendite nette',
    sales_tax: 'Imposta sulle vendite',
    gross_sales: 'Vendite lorde',
    delivery_fee_tax: 'Costo consegna (imposta)',
    delivery_fee_gross: 'Costo consegna (lordo)',
    tips_gross: 'Mance (lordo)',
    total: 'Totale',
  },
  kpi: {
    before_tax: 'al netto delle imposte',
    tips: 'raccolte per il ristorante',
    owed_to_restaurant: 'dovuto al ristorante',
  },
  table: {
    title: 'Dettaglio',
    subtitle: '{{range}} · Tutti gli importi in {{currency}}',
    field: 'Campo',
    amount: 'Importo',
    empty: 'Nessun ordine nel periodo selezionato',
    footnote:
      'Le vendite nette escludono le imposte; le vendite lorde le includono · Il totale è al netto delle commissioni di piattaforma, quindi non corrisponde a quanto pagato dal cliente · Rimborsi e storni vengono sottratti · Importi in {{currency}}',
  },
  buttons: {
    export_csv: 'Esporta CSV',
    refresh: 'Aggiorna',
    retry: 'Riprova',
  },
  errors: {
    failed_to_load: {
      title: 'Impossibile caricare il riepilogo vendite',
      description: 'Si è verificato un errore durante il caricamento del report. Riprova.',
    },
  },
};
